import { addClass, removeClass } from './modules/_utilities';

// Import Foundation libraries
import { Foundation } from 'foundation-sites/js/foundation.core';
import { Keyboard } from 'foundation-sites/js/foundation.util.keyboard';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
// import { Box } from 'foundation-sites/js/foundation.util.box';
// import { onImagesLoaded } from 'foundation-sites/js/foundation.util.imageLoader';
import { Motion } from 'foundation-sites/js/foundation.util.motion';
// import { Nest } from 'foundation-sites/js/foundation.util.nest';
// import { Timer } from 'foundation-sites/js/foundation.util.timer';

// Import initialization method from shared module
import { init } from './modules/_shared.js';

// Expose Foundation to jQuery scope
Foundation.addToJquery($);

// Add imported components to Foundation namespace for compatibility
Foundation.Keyboard = Keyboard;
Foundation.MediaQuery = MediaQuery;
// Foundation.Box = Box;
// Foundation.onImagesLoaded = onImagesLoaded;
Foundation.Motion = Motion;
// Foundation.Move = Move;
// Foundation.Nest = Nest;
// Foundation.Timer = Timer;

import { Touch } from 'foundation-sites/js/foundation.util.touch';
Touch.init($);

import { Triggers } from 'foundation-sites/js/foundation.util.triggers';
Triggers.init($, Foundation);

import { Abide } from 'foundation-sites/js/foundation.abide';
Foundation.plugin(Abide, 'Abide');

import { Accordion } from 'foundation-sites/js/foundation.accordion';
Foundation.plugin(Accordion, 'Accordion');

import { AccordionMenu } from 'foundation-sites/js/foundation.accordionMenu';
Foundation.plugin(AccordionMenu, 'AccordionMenu');

// import { Drilldown } from 'foundation-sites/js/foundation.drilldown';
// Foundation.plugin(Drilldown, 'Drilldown');

// import { Dropdown } from 'foundation-sites/js/foundation.dropdown';
// Foundation.plugin(Dropdown, 'Dropdown');

import { DropdownMenu } from 'foundation-sites/js/foundation.dropdownMenu';
Foundation.plugin(DropdownMenu, 'DropdownMenu');

// import { Equalizer } from 'foundation-sites/js/foundation.equalizer';
// Foundation.plugin(Equalizer, 'Equalizer');

// import { Interchange } from 'foundation-sites/js/foundation.interchange';
// Foundation.plugin(Interchange, 'Interchange');

// import { Magellan } from 'foundation-sites/js/foundation.magellan';
// Foundation.plugin(Magellan, 'Magellan');

// import { OffCanvas } from 'foundation-sites/js/foundation.offcanvas';
// Foundation.plugin(OffCanvas, 'OffCanvas');

import { ResponsiveMenu } from 'foundation-sites/js/foundation.responsiveMenu';
Foundation.plugin(ResponsiveMenu, 'ResponsiveMenu');

import { ResponsiveToggle } from 'foundation-sites/js/foundation.responsiveToggle';
Foundation.plugin(ResponsiveToggle, 'ResponsiveToggle');

import { Reveal } from 'foundation-sites/js/foundation.reveal';
Foundation.plugin(Reveal, 'Reveal');

// import { Slider } from 'foundation-sites/js/foundation.slider';
// Foundation.plugin(Slider, 'Slider');

// import { SmoothScroll } from 'foundation-sites/js/foundation.smoothScroll';
// Foundation.plugin(SmoothScroll, 'SmoothScroll');

import { Sticky } from 'foundation-sites/js/foundation.sticky';
Foundation.plugin(Sticky, 'Sticky');

import { Tabs } from 'foundation-sites/js/foundation.tabs';
Foundation.plugin(Tabs, 'Tabs');

import { Toggler } from 'foundation-sites/js/foundation.toggler';
Foundation.plugin(Toggler, 'Toggler');

// import { Tooltip } from 'foundation-sites/js/foundation.tooltip';
// Foundation.plugin(Tooltip, 'Tooltip');

// import { ResponsiveAccordionTabs } from 'foundation-sites/js/foundation.responsiveAccordionTabs';
// Foundation.plugin(ResponsiveAccordionTabs, 'ResponsiveAccordionTabs');

// lazysizes config object must be declared before script initialization
window.lazySizesConfig = window.lazySizesConfig || {};
/* eslint-disable */
window.data_layer = window.dataLayer || [];
/* eslint-enable */

// import js libraries
import 'lazysizes/plugins/bgset/ls.bgset.min';
import 'lazysizes/lazysizes.min';

// if (typeof jsInclude !== 'undefined') {
//   require(`./modules/_${jsInclude}`).init(); // eslint-disable-line global-require, no-undef
// }

// On DOM load
$(() => {
    $(document).foundation();
    init();
});

// keep any Find button animation from staying shown upon back button press (browser cache)
$(window).bind('pageshow', () => {
    const zipForms = document.querySelectorAll(
        '[data-zip-form], .zip-finder, .zip-form'
    );

    Array.prototype.map.call(zipForms, (el) => {
        // hide spinner animation on buttons
        const zipFormSubmitButton = el.querySelector(
            'button.button--show-spinner'
        );
        removeClass(zipFormSubmitButton, 'button--show-spinner');
        addClass(zipFormSubmitButton, 'button--hide-spinner');

        // add focus event on adjacent inputs to remove spinner if still shown
        const zipFormInput = el.querySelector('input[type="tel"]');
        zipFormInput.value = '';
        zipFormInput.addEventListener('focus', () => {
            removeClass(zipFormSubmitButton, 'button--show-spinner');
            addClass(zipFormSubmitButton, 'button--hide-spinner');
            // console.log('removing animation');
        });
    });
});

/* eslint-disable */

// Eloqua single row form workaround for submitting form without using default submit button
if ($('.eloqua--single-row').length) {
    $('.gfield_label').append('<div class="spinner"></div>');
    $('#gform_wrapper_1').on('click', 'label', function (event) {
        event.preventDefault();

        $(this).closest('form').trigger('submit');
        $('.gfield_label').addClass('button--show-spinner');
        $('.gfield_label')
            .contents()
            .filter((_, el) => el.nodeType === 3)
            .remove();
    });
}

// GF ajax will get rid of "spinner" class, this will add it again in case of failed email
$('#gform_wrapper_1').submit(function () {
    setTimeout(function () {
        $('.gfield_label').append('<div class="spinner"></div>');
    }, 4000);
});

/* eslint-enable */
